export function isNullOrUndefined(value: any) {
    return value === null || value === undefined;
}

export function isNumber(value: any){
    return Number.isInteger(value);
}